import { ref, reactive, computed, onMounted, watch} from "vue";
import {
  ApplicationCargoPickupPartial,
  ApplicationSMSInform,
  SenderPartial,
  ConsigneePartial,
  PackageDistanation,
  ThirdPersonPartial,
  ServicesPartial,
  CargoInformationPartial,
  PaymentPartial,
  SenderPartialCutter,
  PaymentPartialAgree,
  ServicesPartialTab,
  CalculatedResult,
  FinishFrame,
} from "@/partials";
import { BACKEND, U_BACKEND, NEWEST_BACKEND, WORDPRESS } from "@/remotes";
import * as rulesForm from "./rulesForm";
import { USER_ID } from "@/consts";
// import { STYLE_PRINT, FOOTER_PRINT } from "@/constsPrint";
import { getMonthString, getTime } from "@/utils/changeDate";
import { Printer } from "@element-plus/icons-vue";
import { getArrayOfRules } from "@/utils/getDataForm";

import { useDataFormStore } from "@/stores/form";
import { useDataFormStoreApi } from "@/stores/formSave";

import { debounce } from "@/utils/setDebounce";
import axios from "axios";
import { getPackageKey } from "@/utils/tabsFunctions";

import { refreshPackagesAPI } from "@/utils/refreshPackages";

const cityCODBlockList = ["Тарко-Сале", "Муравленко", "Губкинский", "Пурпе (Губкинский)"];

export default {

  components: {
    ApplicationCargoPickupPartial,
    ApplicationSMSInform,
    SenderPartial,
    ConsigneePartial,
    PackageDistanation,
    ThirdPersonPartial,
    FinishFrame,
    CalculatedResult,
    ServicesPartial,
    CargoInformationPartial,
    PaymentPartial,
    SenderPartialCutter,
    PaymentPartialAgree,
    ServicesPartialTab,
  },

  setup() {
    const dataForm = useDataFormStore();
    
    const dataFormApi = useDataFormStoreApi();

    const calcResult = ref([]);

    const calcData = ref([]);

    const citiesFrom = ref([]);
    const citiesTo = ref([]);

    // if(process.env.NODE_ENV == 'development') {
    //   dataForm.sender = {
    //       "first_step_pass": true,
    //       "cityFrom": "Астана",
    //       "officeFrom": {
    //           "id": 93,
    //           "address": " Жиенкуловой 2/1"
    //       },
    //       "officeFromEmpty": false,
    //       "officeFromRefuse": false,
    //       "senderType": false,
    //       "cargoPickUp": "Сдать на склад",
    //       "innSender": "",
    //       "name": "",
    //       "surnameSender": "тест",
    //       "firstNameSender": "тест",
    //       "secondNameSender": "тест",
    //       "phoneSender": "+7 (900) 000-00-00",
    //       "emailSender": ""
    //   }

    //   dataForm.consignee = {
    //     "cityTo": "Белорецк",
    //     "officeTo": {
    //         "id": 6,
    //         "address": " ул Блюхера, д 8"
    //     },
    //     "officeToEmpty": false,
    //     "officeToRefuse": false,
    //     "consigneeType": false,
    //     "cargoDelivery": "Забрать на складе",
    //     "innConsignee": "",
    //     "name": "",
    //     "surnameConsignee": "тест",
    //     "firstNameConsignee": "тест",
    //     "secondNameConsignee": "тест",
    //     "phoneConsignee": "+7 (900) 000-00-00",
    //     "emailConsignee": ""
    //   }
    // }

    // const refreshPackagesDebounce = debounce(() => {
    //   refreshPackagesAPI();
    // }, 500)

    dataForm.cargoWatch = watch(dataForm.cargoInformation, debounce(() => {
      refreshPackagesAPI();
    }, 500)); 

    onMounted(async function () {

      try {
        const { data } = await axios.get("https://xn----stbeziy.xn--p1ai/wp-content/themes/wd_s-main-07-03/inc/new-calc-option.php");
        calcData.value = data;
        dataForm.pageTitle = calcData.value["calc_text"][0];
        dataForm.pageSendTitle = calcData.value["calc_send_text"][0];
        dataFormApi.currencyKZ = calcData.value["currencyKZ"]
      } catch (e) {
        console.log(e);
      }

      try {
        const { data } = await NEWEST_BACKEND.get('/public/cities')

        dataForm.cityDataFrom.value = data;

        data.forEach(element => { 
          citiesFrom.value.push({
            id: element['id'],
            name: element['title']
          }); 
        });

      } catch (e) {
        console.log(e);
      }

      try {
        const { data } = await NEWEST_BACKEND.get('/public/cities')
        
        data.forEach(element => { 
          citiesTo.value.push({
            id: element['id'],
            name: element['title']
          }); 
        });
      } catch (e) {
        console.log(e);
      }
    });

    const ruleForm = reactive({
      applicationCargoPickup: dataForm.applicationCargoPickup,
      sender: dataForm.sender,
      consignee: dataForm.consignee,
      thirdPerson: dataForm.thirdPerson,
      services: dataForm.services,
      cargoInformation: dataForm.cargoInformation,
      payment: dataForm.payment,
      packages: dataForm.packages,
      packagesTabs: dataForm.packagesTabs,
    });

    const rules = reactive({
      // ...rulesForm,
      applicationCargoPickup: rulesForm.applicationCargoPickup(dataForm.applicationCargoPickup),
      sender: rulesForm.sender(dataForm.sender),
      consignee: rulesForm.consignee(dataForm.consignee),
      thirdPerson: rulesForm.thirdPerson(dataForm.thirdPerson),
      cargoInformation: rulesForm.cargoInformation(dataForm.cargoInformation),
      services: rulesForm.services(dataForm.services, dataForm, cityCODBlockList),
      payment: rulesForm.payment(dataForm.payment),
      applicationCargoPickupTime: rulesForm.applicationCargoPickupTime(dataForm.applicationCargoPickupTime),
      other: rulesForm.applicationCargoPickupTime(dataForm.other),
      packages: rulesForm.packages(dataForm.packages, dataForm),
    });

    // Единый источник правды о табах формы.
    // steps — сколько step-counter элементов живёт внутри этого таба.
    // enabled — опциональное условие показа таба; если не задано — таб всегда активен.
    const allTabs = [
      { name: 'services',                      steps: 2 },
      { name: 'cargo-transportation-customer', steps: 1 },
      { name: 'payment',                       steps: 1 },
      { name: 'application-cargo-pickup',      steps: 1 },
      { name: 'application-sms-inform',        steps: 1, enabled: () => dataForm.getSmsTabEnabled },
      { name: 'cargo-information',             steps: 1 },
    ];

    const activeTabs = computed(() =>
      allTabs.filter(tab => !tab.enabled || tab.enabled())
    );

    const formTabs = reactive({
      activeName: "services",
      tabs: activeTabs.value.map(t => t.name),
      arrayFormTads: {
        // eslint-disable-next-line no-unused-vars
        services: [...getArrayOfRules({cityFrom: dataForm.sender.cityFrom, officeFrom: dataForm.sender.officeFrom}, 'sender'),  ...getArrayOfRules({cityTo: dataForm.consignee.cityTo, officeTo: dataForm.consignee.officeTo}, 'consignee'), ...getArrayOfRules((({ typePowerOfAttorney, ...object }) => object)(dataForm.services), 'services')],
        counterparties: [
          // eslint-disable-next-line no-unused-vars
          ...getArrayOfRules((({ officeFrom, ...object }) => object)(dataForm.sender), "sender"),
          // eslint-disable-next-line no-unused-vars
          ...getArrayOfRules((({ officeTo, ...object }) => object)(dataForm.consignee), "consignee"),
          ...getArrayOfRules(dataForm.thirdPerson, "thirdPerson"),
        ],
        payment: [
          ...getArrayOfRules(dataForm.payment, "payment"),
        ],
        applicationCargoPickup: [
          ...getArrayOfRules(dataForm.applicationCargoPickup, "applicationCargoPickup"),
          ...getArrayOfRules(dataForm.applicationCargoPickupTime, "applicationCargoPickupTime")
        ],
        cargoInformation: [
          ...getArrayOfRules(dataForm.cargoInformation, "cargoInformation"),
          ...getArrayOfRules(dataForm.other, "other"),
        ],
        
      },
      // tabsError: {
      //   counterpartiesIsError: false,
      //   applicationCargoPickupIsError: false,
      //   cargoInformationIsError: false,
      //   servicesIsError: false,
      //   paymentIsError: false,
      // }
    });

    const currentTab = () => {
      let tabName = formTabs.activeName;

      // if (tabName == "cargo-information") {
      //   lastPageSwitchStyle();
      // }

        switch (tabName) {
          case "services":
            dataForm.pageTitle = (dataForm.applicationCargoPickup.isCargoPickup) ? calcData.value["calc_send_text"][0] : calcData.value["calc_text"][0];
            break;
          case "cargo-transportation-customer":
            dataForm.pageTitle = (dataForm.applicationCargoPickup.isCargoPickup) ? calcData.value["calc_send_text"][1] : calcData.value["calc_text"][1];
            break;
          case "payment":
            dataForm.pageTitle = (dataForm.applicationCargoPickup.isCargoPickup) ? calcData.value["calc_send_text"][2] : calcData.value["calc_text"][2];
            break;
          case "application-cargo-pickup":
            dataForm.pageTitle = (dataForm.applicationCargoPickup.isCargoPickup) ? calcData.value["calc_send_text"][3] : calcData.value["calc_text"][3];
            break;
          case "cargo-information":
            dataForm.pageTitle = (dataForm.applicationCargoPickup.isCargoPickup) ? calcData.value["calc_send_text"][4] : calcData.value["calc_text"][4];
            break;
        
      }

      // return tabName;
      
    };

    // Синхронизируем formTabs.tabs и счётчики шагов в сторе при изменении набора активных табов.
    // totalSteps = сумма steps всех активных табов + 1 (финальный шаг подтверждения).
    watch(activeTabs, (tabs) => {
      const stepsTotal = tabs.reduce((sum, t) => sum + t.steps, 0) + 1;
      formTabs.tabs = tabs.map(t => t.name);
      dataForm.totalSteps = stepsTotal;
      dataForm.paymentAgreeStep = stepsTotal - 1;
    }, { immediate: true });

    const switchingTabs = (increment) => {
      formTabs.activeName =
        formTabs.tabs[formTabs.tabs.indexOf(formTabs.activeName) + increment];
    };

    const ruleFormRef = ref();

    function parseObjectInNumber(obj) {
      return Object.entries(obj).reduce((accum, [key, value]) => {
        accum[key] = Number(value);
        return accum;
      }, {});
    }

    const parsePhoneNumber = (phone) => Number(phone.replace(/[^0-9]/g, ""));

    const alertInitState = {
      isVisiblePrint: false,
      numberApplication: 0,
      pickupDate: 0,
      cargoStartTimePickup: "",
      cargoEndTimePickup: "",
      orderId: "",
      createTime: {
        day: "",
        month: "",
        year: "",
      },

      cargoCost: "",

      cargoInfo: [],

      cashOnDelivery: "",
      cargoRedemptionSum: "",
      cargoRedemption: false,

      date: {
        day: "",
        month: "",
        year: "",
        time: "",
      },
      sender: {
        inn: "",
        city: "",
        name: "",
        phone: "",
        address: "",
        email: "",
      },
      consignee: {
        inn: "",
        city: "",
        name: "",
        phone: "",
        address: "",
        email: "",
      },
      customer: {
        inn: "",
        city: "",
        name: "",
        phone: "",
        address: "",
        email: "",
      },
      warmPlace: false,
      natureOfCargo: "",
      numberOfIdenticalLoads: "",
      typeOfPackaging: "",
      documentReturn: false,
      smsNotification: true,
    };

    const alertOfApplicationSubmission = reactive({ ...alertInitState });

    function getDateString(date) {
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      return `${parseDate(day)}-${parseDate(month)}-${year}`;
    }

    function parseDate(date) {
      return date < 10 ? `0${date}` : date;
    }

    function getTimeString(date) {
      const hours = date.getHours();
      const minutes = date.getMinutes();
      return `${parseDate(hours)}:${parseDate(minutes)}`;
    }

    function passDataPrint(data, customerAppliction) {
      Object.assign(alertOfApplicationSubmission, alertInitState);

      const joinFullName = (surname, firstName, secondName) =>
        `${surname} ${firstName} ${secondName}`;

      if (dataForm.applicationCargoPickup.isCargoPickup) {
        alertOfApplicationSubmission.pickupDate = getDateString(
          new Date(data.pickUp.pickupsFrom.slice(0, 10))
        );
        alertOfApplicationSubmission.cargoStartTimePickup = getTimeString(
          new Date(data.pickUp.pickupsFrom)
        );
        alertOfApplicationSubmission.cargoEndTimePickup = getTimeString(
          new Date(data.pickUp.pickupsTo)
        );
      }
      alertOfApplicationSubmission.idApplication = data.id;
      alertOfApplicationSubmission.numberApplication = data.number;
      alertOfApplicationSubmission.createTime.day = parseDate(
        new Date(data.createTime.slice(0, 10)).getDate()
      );
      alertOfApplicationSubmission.createTime.month = parseDate(
        new Date(data.createTime.slice(0, 10)).getMonth()
      );
      alertOfApplicationSubmission.createTime.year = parseDate(
        new Date(data.createTime.slice(0, 10)).getFullYear()
      );
      alertOfApplicationSubmission.date.day = new Date(
        data.createTime
      ).getDate();
      alertOfApplicationSubmission.date.month = getMonthString(
        Number(new Date(data.createTime).getMonth())
      );
      alertOfApplicationSubmission.date.year = new Date(
        data.createTime
      ).getFullYear();
      alertOfApplicationSubmission.date.time = getTimeString(
        new Date(data.createTime)
      );
      alertOfApplicationSubmission.orderId = data.cashOnDelivery.order;
      alertOfApplicationSubmission.cashOnDelivery = data.cashOnDelivery.sum;
      if (data.repurchaseCargo === null) {
        alertOfApplicationSubmission.cargoRedemptionSum = "";
      } else {
        alertOfApplicationSubmission.cargoRedemptionSum =
          data.repurchaseCargo.sum || 0;
        alertOfApplicationSubmission.cargoRedemption =
          data.repurchaseCargo.whoRepurchaseCargo == 1;
      }
      alertOfApplicationSubmission.cargoCost = data.cargoList[0].value;

      alertOfApplicationSubmission.sender = {
        inn: data.sender.corpClient === null ? "" : data.sender.corpClient.inn,
        city: data.transportation.cityFrom,
        name:
          data.sender.corpClient === null
            ? data.sender.name
            : data.sender.corpClient.title,
        phone: data.sender.phone,
        email: data.sender.email || "",
        address: dataForm.applicationCargoPickup.isCargoPickup ? dataForm.applicationCargoPickup.adressDetailRequired ? dataForm.applicationCargoPickup.addressCargoPickupNotice : dataForm.applicationCargoPickup.addressCargoPickup : "",
        corpClient: {
          inn: dataForm.sender.senderType ? 
          dataForm.sender.innSender : "",
          title: dataForm.sender.senderType ? 
          dataForm.sender.name : joinFullName(
            dataForm.sender.surnameSender,
            dataForm.sender.firstNameSender,
            dataForm.sender.secondNameSender
          ),
          fullTitle: dataForm.sender.senderType ? 
          dataForm.sender.name : joinFullName(
            dataForm.sender.surnameSender,
            dataForm.sender.firstNameSender,
            dataForm.sender.secondNameSender
          ),
        },
      };

      alertOfApplicationSubmission.consignee = {
        inn:
          data.consignee.corpClient === null
            ? ""
            : data.consignee.corpClient.inn,
        city: data.transportation.cityTo,
        name:
          data.consignee.corpClient === null
            ? data.consignee.name
            : data.consignee.corpClient.title,
        phone: data.consignee.phone,
        email: data.consignee.email || "",
        address: dataForm.applicationCargoPickup.deliveryToTheAddress ? dataForm.applicationCargoPickup.adressDetailRequiredTo ? dataForm.applicationCargoPickup.addressCargoPickupNoticeTo : dataForm.applicationCargoPickup.addressConsignee : "",
        corpClient: {
          inn: dataForm.consignee.consigneeType ? 
          dataForm.consignee.innConsignee : "",
          title: dataForm.consignee.consigneeType ?
          dataForm.consignee.name : joinFullName(
            dataForm.consignee.surnameConsignee,
            dataForm.consignee.firstNameConsignee,
            dataForm.consignee.secondNameConsignee
          ),
          fullTitle: dataForm.consignee.consigneeType ?
          dataForm.consignee.name : joinFullName(
            dataForm.consignee.surnameConsignee,
            dataForm.consignee.firstNameConsignee,
            dataForm.consignee.secondNameConsignee
          ),
        },
      };
      alertOfApplicationSubmission.isDelivery = data.delivery ? true : false;

      if (customerAppliction === "Отправитель") {
        alertOfApplicationSubmission.customer =
          alertOfApplicationSubmission.sender;
      } else if (customerAppliction === "Получатель") {
        alertOfApplicationSubmission.customer =
          alertOfApplicationSubmission.consignee;
      } else {
        alertOfApplicationSubmission.customer = {
          inn:
            data.customer.corpClient === null
              ? ""
              : data.customer.corpClient.inn,
          name:
            data.customer.corpClient === null
              ? data.customer.name
              : data.customer.corpClient.title,
          phone: data.customer.phone,
          email: data.customer.email || "",
          corpClient: {
            inn: dataForm.thirdPerson.typeThirdPerson ? 
            dataForm.thirdPerson.innThirdPerson : "",
            title: dataForm.thirdPerson.typeThirdPerson ? 
            dataForm.thirdPerson.name : joinFullName(
              dataForm.thirdPerson.surnameThirdPerson,
              dataForm.thirdPerson.firstNameThirdPerson,
              dataForm.thirdPerson.secondNameThirdPerson
            ),
            fullTitle: dataForm.thirdPerson.typeThirdPerson ? 
              dataForm.thirdPerson.name : joinFullName(
                dataForm.thirdPerson.surnameThirdPerson,
                dataForm.thirdPerson.firstNameThirdPerson,
                dataForm.thirdPerson.secondNameThirdPerson
              ),
          },
        };
      }
      alertOfApplicationSubmission.cargoInfo = data.cargoList;
      alertOfApplicationSubmission.natureOfCargo =
        data.cargoList[0].cargoDescription;
      alertOfApplicationSubmission.warmPlace = data.cargoList[0].warmPlace;
      alertOfApplicationSubmission.numberOfIdenticalLoads =
        data.cargoList[0].numberOfIdenticalLoads;
      alertOfApplicationSubmission.typeOfPackaging = checkTypesPackaging(data);

      alertOfApplicationSubmission.payment = { ...dataForm.payment };
      alertOfApplicationSubmission.documentReturn = data.documentReturn;

      alertOfApplicationSubmission.isVisiblePrint = true;
      dataForm.isOrderDone = true;

      document.querySelector(".calculator__title").innerHTML = "Спасибо, что выбрали нас!"
      formTabs.activeName = formTabs.tabs[0]

      window.scrollTo({ top: 0, behavior: 'smooth' });

      if(dataForm.consignee.innConsignee != "9714053621") {
          dataForm.consignee.name = "";
          dataForm.consignee.surnameConsignee = "";
          dataForm.consignee.firstNameConsignee = "";
          dataForm.consignee.secondNameConsignee = "";
          dataForm.consignee.secondNameConsignee = "";
          dataForm.consignee.phoneConsignee = "";
          dataForm.consignee.emailConsignee = "";
      }
      

      dataForm.services.cashOnDelivery = false;
      dataForm.services.cashOnDeliverySum = null;
      dataForm.services.cargoRedemption = false;
      dataForm.services.cargoRedemptionSum = null;
      dataForm.services.whoPaysTheRansom = "";
    }

    function checkTypesPackaging(data) {
      const typePackaging = [
        { palletizing: "Паллетирование" },
        { stretchFilm: "Стретч" },
        { lathing: "Обрешётка" },
        { poddon: "Поддон" },
        { box25x18x10: "Коробка Мини" },
        { box38x30x23: "Коробка Стандарт" },
        { packet: "Пакет" },
        { uniPakMini: "УниПАК Мини" },
        { uniPakStandard: "УниПАК Стандарт" },
      ];
      let arrayTypes = [];
      for (const type of typePackaging) {
        data.cargoList[0][Object.keys(type)[0]]
          ? arrayTypes.push(Object.values(type)[0])
          : 0;
      }
      return arrayTypes.length ? arrayTypes : "Отказ";
    }

    function pagePrint(calculatedData) {
      setTimeout(() => {
        const win = window.open('about:blank', '', '_top, alwaysRaised=yes');
        const html = calculatedData;
        win.document.write(html);
        win.focus();

        setTimeout(() => {
          win.print();
          // win.close();
          // alertOfApplicationSubmission.isVisiblePrint = false;
        }, 100);
        
      })
    }

    function pagePrintTalons(calculatedData) {
      setTimeout(() => {
        const win = window.open('about:blank', '', '_top, alwaysRaised=yes');
        const html = calculatedData;
        win.document.write(html);
        win.focus();

        
        setTimeout(() => {
          win.print();
          // win.close();
          // alertOfApplicationSubmission.isVisiblePrint = false;
        }, 100);
        
        
      })
    }

    async function checkValidTab(arrayRules) {
      try {
        await ruleFormRef.value.validateField(arrayRules);
      } catch (e) {
        return false;
      }
      return true;
    }

    function getTypeOfCargo(type) {
      switch (type) {
        case "Стандарт":
          return "Standart";
        case "Цилиндры":
          return "Cylinder";
        case "Шины":
          return "Tires";
      }
    }

    

    const calculatePackage = async function () {

      

      if(
        (dataForm.cargoInformation.cargoWeight == '') ||
        (dataForm.cargoInformation.cargoDimensions.width == '') ||
        (dataForm.cargoInformation.cargoDimensions.length == '') ||
        (dataForm.cargoInformation.cargoDimensions.height == '') ||
        (dataForm.cargoInformation.sizeOfCargoCylinder.height == '') ||
        (dataForm.cargoInformation.sizeOfCargoCylinder.diameter == '') ||
        (dataForm.cargoInformation.numberOfIdenticalLoads == '') ||
        (dataForm.other.cargoCost < 3000)
      ) return;

      let cargoVolumeDisplay = 0;
      let cargoWeightDisplay = 0;

      /////////////////////////////////////// Проверка на заполненность
      if (
        dataForm.sender.cityFrom != "" &&
        dataForm.consignee.cityTo != ""
      ) {

        // let cash_on_deliveryData = document.querySelector(
        //     ".calculator__toggle-input"
        // ).value;

        let cargoSpace = [];
        if (dataForm.cargoInformation.cargoSpaceType == "simple") {

            let calcVolume = 0;
            let calcWeight = 0;

              switch (getTypeOfCargo(dataForm.cargoInformation.typeOfCargo)) {
                case 'Standart':
                  calcVolume = parseFloat(dataForm.cargoInformation.cargoVolume.toString().replace(/,/g, '.'));
                  calcWeight = parseFloat(dataForm.cargoInformation.cargoWeight.toString().replace(/,/g, '.'));
                  cargoVolumeDisplay = Number(calcVolume);
                  cargoWeightDisplay = Number(calcWeight);
                  break;
                case 'Cylinder':
                  calcVolume = Math.PI * (Math.pow(dataForm.cargoInformation.sizeOfCargoCylinder.diameter, 2) / 4) * dataForm.cargoInformation.sizeOfCargoCylinder.height / 1000000;
                  calcWeight = parseFloat(dataForm.cargoInformation.cargoWeight.toString().replace(/,/g, '.'));
                  cargoVolumeDisplay = Number(calcVolume);
                  cargoWeightDisplay = Number(calcWeight);
                  break;
                case 'Tires':
                  calcVolume = 0.085;
                  calcWeight = 8;
                  cargoVolumeDisplay = Number(calcVolume) * dataForm.cargoInformation.numberOfIdenticalLoads;
                  cargoWeightDisplay = Number(calcWeight) * dataForm.cargoInformation.numberOfIdenticalLoads;
                  break;
              } 
              
              cargoSpace.push({
                cargoType: getTypeOfCargo(dataForm.cargoInformation.typeOfCargo),
                attachmentCount: Number(dataForm.cargoInformation.numberOfIdenticalLoads),
                diametr: (getTypeOfCargo(dataForm.cargoInformation.typeOfCargo) == "Cylinder") ? parseFloat(dataForm.cargoInformation.sizeOfCargoCylinder.diameter) : 0,
                length: (getTypeOfCargo(dataForm.cargoInformation.typeOfCargo) == "Cylinder") ? 1 : parseFloat(dataForm.cargoInformation.cargoDimensions.length),
                width: (getTypeOfCargo(dataForm.cargoInformation.typeOfCargo) == "Cylinder") ? 1 : parseFloat(dataForm.cargoInformation.cargoDimensions.width),
                height: (getTypeOfCargo(dataForm.cargoInformation.typeOfCargo) == "Cylinder") ? parseFloat(dataForm.cargoInformation.sizeOfCargoCylinder.height) : parseFloat(dataForm.cargoInformation.cargoDimensions.height),
                weight: calcWeight,
                volume: calcVolume,
                cargoExtraPacking: 
                {
                  palletizing: (dataForm.packages.additionalPackagingGroup.includes("Паллетирование")) ? true : false,
                  stretchWrap: (dataForm.packages.additionalPackagingGroup.includes("Стретч")) ? true : false,
                  lathing: (dataForm.packages.additionalPackagingGroup.includes("Обрешётка")) ? true : false,
                  pallet: (dataForm.packages.additionalPackagingGroup.includes("Поддон")) ? true : false, 
                  boxes: (dataForm.packages.additionalPackagingGroup.includes("Коробка Мини")) ? "Size25x18x10" : (dataForm.packages.additionalPackagingGroup.includes("Коробка Стандарт")) ? "Size38x30x23" : (dataForm.packages.additionalPackagingGroup.includes("Пакет")) ? "3" : "none",
                  packet: false,
                  warmplace: (dataForm.packages.additionalPackagingGroup.includes("Термобокс")) ? true : false,
                  mattressCover: (dataForm.packages.additionalPackagingGroup.includes("Наматрасник")) ? true : false,
                  uniPakMini: (dataForm.packages.additionalPackagingGroup.includes("УниПАК Мини")) ? true : false,
                  uniPakStandard: (dataForm.packages.additionalPackagingGroup.includes("УниПАК Стандарт")) ? true : false,
                }
              });
            
        } else {

          let calcVolume = 0;
          let calcWeight = 0;
      
          dataForm.cargoSpaceTabs.forEach((tab) => {

            switch (getTypeOfCargo(tab.typeOfCargo)) {
              case 'Standart':
                calcVolume = parseFloat(tab.cargoVolume.toString().replace(/,/g, '.'));
                calcWeight = parseFloat(tab.cargoWeight.toString().replace(/,/g, '.'));
                cargoVolumeDisplay += Number(calcVolume);
                cargoWeightDisplay += Number(calcWeight);
                break;
              case 'Cylinder':
                calcVolume = Math.PI * (Math.pow(tab.diameter, 2) / 4) * tab.height / 1000000;
                calcWeight = parseFloat(tab.cargoWeight.toString().replace(/,/g, '.'));
                cargoVolumeDisplay += Number(calcVolume);
                cargoWeightDisplay += Number(calcWeight);
                break;
              case 'Tires':
                calcVolume = 0.085;
                calcWeight = 8;
                cargoVolumeDisplay += Number(calcVolume);
                cargoWeightDisplay += Number(calcWeight);
                break;
            }

            let tabPackage = dataForm.packagesTabs[getPackageKey(tab.name)];
            cargoSpace.push({
              cargoType: getTypeOfCargo(tab.typeOfCargo),
              attachmentCount: 1,
              diametr: (getTypeOfCargo(tab.typeOfCargo) == "Cylinder") ? parseFloat(tab.diameter) : 0,
              length: (getTypeOfCargo(tab.typeOfCargo) == "Cylinder") ? 1 : parseFloat(tab.length),
              width: (getTypeOfCargo(tab.typeOfCargo) == "Cylinder") ? 1 : parseFloat(tab.width),
              height: parseFloat(tab.height),
              weight: calcWeight,
              volume: calcVolume,
              cargoExtraPacking: (tab.additionalPackaging == "false") ? 
              {
                warmplace: (tabPackage.additionalPackagingGroup.includes("Термобокс")) ? true : false,
              } : {
                palletizing: (tabPackage.additionalPackagingGroup.includes("Паллетирование")) ? true : false,
                stretchWrap: (tabPackage.additionalPackagingGroup.includes("Стретч")) ? true : false,
                lathing: (tabPackage.additionalPackagingGroup.includes("Обрешётка")) ? true : false,
                pallet: (tabPackage.additionalPackagingGroup.includes("Поддон")) ? true : false, 
                boxes: (tabPackage.additionalPackagingGroup.includes("Коробка Мини")) ? "Size25x18x10" : (tabPackage.additionalPackagingGroup.includes("Коробка Стандарт")) ? "Size38x30x23" : (tabPackage.additionalPackagingGroup.includes("Пакет")) ? "3" : "none",
                packet: false,
                warmplace: (tabPackage.additionalPackagingGroup.includes("Термобокс")) ? true : false,
                mattressCover: (tabPackage.additionalPackagingGroup.includes("Наматрасник")) ? true : false,
                uniPakMini: (tabPackage.additionalPackagingGroup.includes("УниПАК Мини")) ? true : false,
                uniPakStandard: (tabPackage.additionalPackagingGroup.includes("УниПАК Стандарт")) ? true : false,
              }
            });
          })
        }

        let cargoPickUp = dataForm.applicationCargoPickup.isCargoPickup;
        let cargoDelivery = dataForm.applicationCargoPickup.deliveryToTheAddress;

        

        

        
          


        let queryData = {
            cityFrom: dataForm.sender.cityFrom,
            cityTo: dataForm.consignee.cityTo,
            cargoSpace: cargoSpace,
            cargoPickUp: cargoPickUp,
            cargoDelivery: cargoDelivery,
            timeWaitingOnPickUp: 0,
            timeWaitingOnDelivery: 0,
            PriorityPickup: dataForm.applicationCargoPickup.optionPickUp == 2,
            PriorityDelivery: dataForm.applicationCargoPickup.optionDelivery == 2,
            ByTimePickup: dataForm.applicationCargoPickup.optionPickUp == 1,
            ByTimeDelivery: dataForm.applicationCargoPickup.optionDelivery == 1,
            cargoDeclaredValue: Number(dataForm.other.cargoCost),
            cargoRedemptionAmount: dataForm.services.cargoRedemption
            ? Number(dataForm.services.cargoRedemptionSum)
            : 0,
            cashOnDeliveryAmount: dataForm.services.cashOnDelivery
              ? Number(dataForm.services.cashOnDeliverySum)
              : 0,
            returnOfDocuments: dataForm.services.returnOfDocuments,
            smsNotification: dataForm.smsNotification ?? false,
            consignee_inn: 
            (() => {
                const tp = (dataForm.other?.payers ?? []).find(p => !!p.services['transport']);
                if (!tp) return '';
                if (!dataForm.thirdPerson.cargoTransportationCustomer) return dataForm.consigneeInnRadio ? 7404067356 : '';
                if (tp.person === 'Отправитель')  return dataForm.sender.senderType       ? 7404067356 : '';
                if (tp.person === 'Получатель')   return dataForm.consignee.consigneeType  ? 7404067356 : '';
                if (tp.person === 'Третье лицо')  return dataForm.thirdPerson.typeThirdPerson ? 7404067356 : '';
                return '';
            })(),
        };
        dataFormApi.sumText = 'Загрузка...'

        dataFormApi.commonPrice = 'Загрузка...'

        let queryDataForAPI = JSON.stringify(queryData);

        let param = {
            headers: {
                'Content-Type': 'application/json',
            }
        }

        try {
          
          const { data } = await U_BACKEND.post(`/calc/site?userid=${USER_ID}`, queryDataForAPI, param);
          calcResult.value = data;
          dataFormApi.sumText = calcResult.value.shippingCost.total;

          // let cargoVolume = 0;
          // let totalWeight = 0;

          // if (dataForm.cargoInformation.cargoSpaceType == 'simple') {
          //   cargoVolume = dataForm.cargoInformation.cargoVolume;
          //   totalWeight = calcResult.value.totalWeight;
          // } else {
          //   dataForm.cargoSpaceTabs.forEach(element => {
          //     cargoVolume += parseFloat(element.cargoVolume);
          //     totalWeight += element.cargoWeight;
          //   });
          // }

          dataFormApi.commonPrice = calcResult.value.shippingCost.total;
          dataFormApi.cargoVolume = Number(Number(cargoVolumeDisplay).toFixed(3)); //cargoVolumeDisplay
          dataFormApi.totalWeight = Number(Number(cargoWeightDisplay).toFixed(3));
          dataFormApi.transportation = calcResult.value.shippingCost.transportation;
          dataFormApi.cargoPickUp = calcResult.value.shippingCost.cargoPickUp;
          dataFormApi.extraChargeForCargoPickUp = calcResult.value.shippingCost.extraChargeForCargoPickUp;
          dataFormApi.extraChargeForCargoDelivery = calcResult.value.shippingCost.extraChargeForCargoDelivery;
          dataFormApi.costForReturningDocuments = calcResult.value.shippingCost.costForReturningDocuments;
          dataFormApi.cargoDelivery = calcResult.value.shippingCost.cargoDelivery;
          dataFormApi.package = calcResult.value.shippingCost.package;
          dataFormApi.costWarranty = calcResult.value.shippingCost.costWarranty;
          dataFormApi.smsNotification = calcResult.value.shippingCost.costForSmsNotification;
          dataFormApi.costForTheRedemptionOfCargo = calcResult.value.shippingCost.costForTheRedemptionOfCargo;
          dataFormApi.cashOnDeliveryAmount = calcResult.value.shippingCost.cashOnDeliveryAmount;
          dataFormApi.warmPlace = calcResult.value.shippingCost.warmPlace;
          dataFormApi.costForByTimeDelivery = calcResult.value.shippingCost.costForByTimeDelivery;
          dataFormApi.costForByTimePickup = calcResult.value.shippingCost.costForByTimePickup;
          dataFormApi.costForPriorityDelivery = calcResult.value.shippingCost.costForPriorityDelivery;
          dataFormApi.costForPriorityPickup = calcResult.value.shippingCost.costForPriorityPickup;
          
          if(!dataForm.firstCalc) {
            dataForm.cityDropdown = true;
            dataForm.detailsDropdown = true;

            setTimeout(() => {
              document.querySelector('.result-frames__wrapper').setAttribute("style", "min-height: " + ((dataForm.detailsDropdown || dataForm.cityDropdown) ? document.querySelector("[data-frame='2']").offsetHeight+"px" : "75px"));
            }, 500);
            
            dataForm.firstCalc = true;
          }
          

        } catch (e) {
          console.log(e);
        }
      }
    }

    const getcalculatePackage = debounce(calculatePackage, 500);

    dataForm.$subscribe(() =>{
      
      if(!dataForm.events.selecting && !dataForm.events.requestEnd) getcalculatePackage();
    },{})

    watch(dataForm.events , () => {
      if(dataForm.events.selecting == true) {dataForm.events.requestEnd = dataForm.events.selecting}
    });

    getcalculatePackage();

    // function lastPageSwitchStyle() {
    //   if(document.querySelector(".result-frames__wrapper")) {
    //     document.querySelector(".result-frames__wrapper").classList.add("result-frames__wrapper_last-page")
    //     document.querySelector(".frame__city__inner").classList.add("frame__city__inner_last-page")
    //   }
    // }

    return {
      calcResult,
      dataForm,
      dataFormApi,
      calculatePackage,
      currentTab,
      calcData,
      citiesTo,
      citiesFrom,

      alertOfApplicationSubmission,
      Printer,

      ruleFormRef,
      ruleForm,
      rules,

      formTabs,

      parseObjectInNumber,
      parsePhoneNumber,
      parseDate,

      clickFormButtonBack: function () {
        switchingTabs(-1);
        currentTab();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      },

      clickFormButtonNext: async function (arrayRules, additionalChecks = true, failTabName = null) {
        const isValidForm = await checkValidTab(arrayRules);

        if (isValidForm && additionalChecks) {
          window.scrollTo({ top: 0, behavior: 'smooth' });
          await ruleFormRef.value.clearValidate();
          switchingTabs(1);
          currentTab();
        } else if (!isValidForm && failTabName) {
          formTabs.activeName = failTabName;
        }

      },

      clickForFirstPage: async function (arrayRules) {
        const isValidForm = await checkValidTab(arrayRules);
        let noRightTab = 0;
        let weightAll = 0;
        if (isValidForm) {
          window.scrollTo({ top: 0, behavior: 'smooth' });

          dataForm.cargoSpaceTabs.forEach((tab, index) => {
            let isValidMulti = true;
            if (tab.cargoWeight > dataForm.restrictions.weight) isValidMulti = false;
            if (isValidMulti == false) {
              noRightTab = index+1;
            }
          })

          dataForm.cargoSpaceTabs.forEach((tab) => {
            weightAll += parseInt(tab.cargoWeight)
          })

          if (weightAll > dataForm.restrictions.weightUnit) noRightTab = 1;    
          if (dataForm.cargoInformation.cargoWeight / dataForm.cargoInformation.numberOfIdenticalLoads > dataForm.restrictions.weight) noRightTab = 1;
          if (dataForm.cargoInformation.cargoWeight > dataForm.restrictions.weightUnit) noRightTab = 1;
          
          await ruleFormRef.value.clearValidate();
          if ((noRightTab == 0)) {
            if(dataForm.other.cargoCost === 3000) {
              dataForm.decalreWindowShow = true;
            } else {
              dataForm.sender.first_step_pass = true;
            }
          } else {
            dataForm.cargoSpaceData = (noRightTab).toString()
          }
        }
      },

      submitFormSender: async (formEl) => {
        const inputs = document.querySelectorAll('input, textarea, select');
        inputs.forEach(input => input.blur());
        
        const isValideForm = await formEl.validate((valid) => valid);

        if (!isValideForm) {
          for (let i = 0; i < formTabs.tabs.length; i++) {
            if (
              !(await checkValidTab(
                formTabs.arrayFormTads[Object.keys(formTabs.arrayFormTads)[i]]
              ))
            ) {
              formTabs.activeName = formTabs.tabs[i];
              return;
            }
          }
          // formTabs
          return;
        }

        document.querySelector("body").classList.add("loading-splash");

        const check = (value) => (value === "Наличные" ? 0 : 1);

        // Источник истины — новая система карточек плательщиков
        const payers = dataForm.other?.payers ?? [];
        const getPayerForService = (service) => payers.find(p => !!p.services[service]);

        const transportPayer = getPayerForService('transport');
        const pickupPayer    = getPayerForService('pickup');
        const deliveryPayer  = getPayerForService('delivery');

        const typeTransportation = check(transportPayer?.paymentType ?? 'Наличные');
        const typePickup         = check(pickupPayer?.paymentType    ?? 'Наличные');
        const typeDelivery       = check(deliveryPayer?.paymentType  ?? 'Наличные');
        const typeExtraPacking   = typeTransportation;

        function generateObligation() {
          return {
            ptAddrPickUp: typePickup,
            ptGasolinePickUp: typePickup,
            ptCarrying: typeTransportation,
            ptSmsNotification: typeTransportation,
            ptAddrDelivery: typeDelivery,
            ptGasolineDelivery: typeDelivery,
            ptPacking: typeExtraPacking,
          };
        }

        function generateObligationPattern(isControgent) {
          const isWhoPayPickup         = pickupPayer?.person    === isControgent;
          const isWhoPayTransportation = transportPayer?.person === isControgent;
          const isWhoPayDelivery       = deliveryPayer?.person  === isControgent;
          const isWhoPayExtraPacking   = isWhoPayTransportation;
          const isWhoPayExtraSMS       = isWhoPayTransportation && dataForm.smsNotification;

          const type = isWhoPayPickup         ? typePickup
                     : isWhoPayTransportation ? typeTransportation
                     : isWhoPayDelivery       ? typeDelivery
                     : isWhoPayExtraPacking   ? typeExtraPacking
                     : 1;

          return {
            addrPickUp: isWhoPayPickup,
            gasolinePickUp: isWhoPayPickup,
            waitingPickUp: isWhoPayPickup,
            carrying: isWhoPayTransportation,
            returnDocs: dataForm.services.returnOfDocuments && isWhoPayTransportation,
            ptReturnDocs: type,
            addrDelivery: isWhoPayDelivery,
            waitingDelivery: isWhoPayDelivery,
            gasolineDelivery: isWhoPayDelivery,
            packing: isWhoPayExtraPacking,
            warmPlace: isWhoPayExtraPacking,
            ptAddrPickUp: type,
            ptGasolinePickUp: type,
            ptWaitingPickUp: type,
            ptCarrying: type,
            ptAddrDelivery: type,
            ptGasolineDelivery: type,
            ptWaitingDelivery: type,
            ptPacking: type,
            ptWarmPlace: type,
            insuranceForValue: isWhoPayTransportation,
            ptInsuranceForValue: type,
            smsNotification: isWhoPayExtraSMS,
            ptSmsNotification: type,
          };
        }

        function getBreakTime(time) {
          if (!time) {
            return;
          }
          const today = new Date();
          today.setHours(Number(time.slice(0, 2)), Number(time.slice(3, 5)));
          return today.toISOString().slice(11, 19);
        }

        function getTypeOfCargo(type) {
          switch (type) {
            case "Стандарт":
              return "Standart";
            case "Цилиндры":
              return "Cylinder";
            case "Шины":
              return "Tires";
          }
        }

        function getTypeOfPackaging(types) {
          return {
            palletizing: types.includes("Паллетирование"),
            stretchFilm: types.includes("Стретч"),
            lathing: types.includes("Обрешётка"),
            poddon: types.includes("Поддон"),
            box25x18x10: types.includes("Коробка Мини"),
            box38x30x23: types.includes("Коробка Стандарт"),
            packet: types.includes("Пакет"),
            uniPakMini: types.includes("УниПАК Мини"),
            uniPakStandard: types.includes("УниПАК Стандарт"),
          };
        }

        const joinFullName = (surname, firstName, secondName) =>
          `${surname} ${firstName} ${secondName}`;

        let CargoListArray = [];

        if (dataForm.cargoInformation.cargoSpaceType == "simple") {
          if (dataForm.packages.additionalPackagingGroup.length > 0) {
            CargoListArray.push(
              {
                cargoDescription: (dataForm.cargoInformation.natureOfCargo.title) ? dataForm.cargoInformation.natureOfCargo.title : '',
                typeOfCargo: getTypeOfCargo(dataForm.cargoInformation.typeOfCargo),
                value: Number(dataForm.other.cargoCost),
                weight: dataForm.cargoInformation.cargoWeight
                  ? parseFloat(dataForm.cargoInformation.cargoWeight.toString().replace(/,/g, '.'))
                  : 14.0,
                ...getTypeOfPackaging(dataForm.packages.additionalPackagingGroup),
                numberOfIdenticalLoads: Number(
                  dataForm.cargoInformation.numberOfIdenticalLoads
                ),
                warmPlace: (dataForm.packages.additionalPackagingGroup.includes("Термобокс")) ? true : false,
                sizeOfCargoBox:
                  getTypeOfCargo(dataForm.cargoInformation.typeOfCargo) ===
                  "Standart"
                    ? parseObjectInNumber({
                        length: dataForm.cargoInformation.cargoDimensions.length
                          ? parseFloat(dataForm.cargoInformation.cargoDimensions.length).toFixed()
                          : 43,
                        width: dataForm.cargoInformation.cargoDimensions.width
                          ? parseFloat(dataForm.cargoInformation.cargoDimensions.width).toFixed()
                          : 21,
                        height: dataForm.cargoInformation.cargoDimensions.height
                          ? parseFloat(dataForm.cargoInformation.cargoDimensions.height).toFixed()
                          : 39,
                      })
                    : null,
                sizeOfCargoCylinder:
                  getTypeOfCargo(dataForm.cargoInformation.typeOfCargo) ===
                  "Standart"
                    ? null
                    : getTypeOfCargo(dataForm.cargoInformation.typeOfCargo) ===
                      "Tires"
                    ? { tire: true }
                    : { ...dataForm.cargoInformation.sizeOfCargoCylinder },
              },
            )
          } else {

            let volume = parseFloat(dataForm.cargoInformation.cargoDimensions.length).toFixed() * parseFloat(dataForm.cargoInformation.cargoDimensions.width).toFixed() * parseFloat(dataForm.cargoInformation.cargoDimensions.height).toFixed();

            let volumeCylinder = Math.PI * Math.pow(parseFloat(dataForm.cargoInformation.sizeOfCargoCylinder.diameter).toFixed(), 2) / 4 * parseFloat(dataForm.cargoInformation.sizeOfCargoCylinder.height).toFixed()

            for (let i = 0; i < Number(dataForm.cargoInformation.numberOfIdenticalLoads); i++) {
              CargoListArray.push(
                {
                  cargoDescription: (dataForm.cargoInformation.natureOfCargo.title) ? dataForm.cargoInformation.natureOfCargo.title : '',
                  typeOfCargo: getTypeOfCargo(dataForm.cargoInformation.typeOfCargo),
                  value: Number(dataForm.other.cargoCost),
                  weight: dataForm.cargoInformation.cargoWeight
                    ? parseFloat(dataForm.cargoInformation.cargoWeight.toString().replace(/,/g, '.')) / Number(dataForm.cargoInformation.numberOfIdenticalLoads)
                    : 14.0,
                  ...getTypeOfPackaging(dataForm.packages.additionalPackagingGroup),
                  numberOfIdenticalLoads: 1,
                  warmPlace: (dataForm.packages.additionalPackagingGroup.includes("Термобокс")) ? true : false,
                  sizeOfCargoBox:
                    getTypeOfCargo(dataForm.cargoInformation.typeOfCargo) ===
                    "Standart"
                      ? parseObjectInNumber({
                          length: dataForm.cargoInformation.cargoDimensions.length
                            ? Math.cbrt(volume / Number(dataForm.cargoInformation.numberOfIdenticalLoads)).toFixed(2)
                            : 43,
                          width: dataForm.cargoInformation.cargoDimensions.width
                            ? Math.cbrt(volume / Number(dataForm.cargoInformation.numberOfIdenticalLoads)).toFixed(2)
                            : 21,
                          height: dataForm.cargoInformation.cargoDimensions.height
                            ? Math.cbrt(volume / Number(dataForm.cargoInformation.numberOfIdenticalLoads)).toFixed(2)
                            : 39,
                        })
                      : null,
                  sizeOfCargoCylinder:
                    getTypeOfCargo(dataForm.cargoInformation.typeOfCargo) ===
                    "Standart"
                      ? null
                      : getTypeOfCargo(dataForm.cargoInformation.typeOfCargo) ===
                        "Tires"
                      ? { tire: true }
                      : { 
                        diameter: Math.cbrt(volumeCylinder * 4 / Math.PI),
                        height: Math.cbrt(volumeCylinder * 4 / Math.PI)
                        },
                },
              )
            }
            
          }
          
        } else {
          dataForm.cargoSpaceTabs.forEach((tab) => {
            CargoListArray.push({
              cargoDescription: (tab.natureOfCargo.title) ? tab.natureOfCargo.title : '',
              typeOfCargo: getTypeOfCargo(tab.typeOfCargo),
              value: Number(dataForm.other.cargoCost),
              weight: tab.cargoWeight
                ? parseFloat(tab.cargoWeight.toString().replace(/,/g, '.'))
                : 14.0,
              ...getTypeOfPackaging(dataForm.packagesTabs[getPackageKey(tab.name)].additionalPackagingGroup),
              numberOfIdenticalLoads: Number(
                1
              ),
              warmPlace: (dataForm.packagesTabs[getPackageKey(tab.name)].additionalPackagingGroup.includes("Термобокс")) ? true : false,
              sizeOfCargoBox:
                getTypeOfCargo(tab.typeOfCargo) ===
                "Standart"
                  ? parseObjectInNumber({
                      length: tab.length
                        ? parseFloat(tab.length).toFixed()
                        : 43,
                      width: tab.width
                        ? parseFloat(tab.width).toFixed()
                        : 21,
                      height: tab.height
                        ? parseFloat(tab.height).toFixed()
                        : 39,
                    })
                  : null,
              sizeOfCargoCylinder:
                getTypeOfCargo(tab.typeOfCargo) ===
                "Standart"
                  ? null
                  : getTypeOfCargo(tab.typeOfCargo) ===
                    "Tires"
                  ? { tire: true }
                  : { ...{diameter: parseFloat(tab.diameter).toFixed(0), height: parseFloat(tab.height).toFixed(0)} },


              
            });
          })
        }

        const resolvePickUpTimeFields = (option) => {
          const base = option ? { additionalServiceId: option} : undefined;

          if (option === 1 && dataForm.applicationCargoPickup.requestedTimePickup) {
            const t = dataForm.applicationCargoPickup.requestedTimePickup;
            const [h, m] = t.split(':').map(Number);
            const endMin = Math.min(h * 60 + m + 1, 23 * 60 + 59);
            const endStr = `${String(Math.floor(endMin / 60)).padStart(2, '0')}:${String(endMin % 60).padStart(2, '0')}`;
            return {
              ...base,
              pickupsFrom: getTime(dataForm.applicationCargoPickup.pickupDate, t),
              pickupsTo: getTime(dataForm.applicationCargoPickup.pickupDate, endStr),
            };
          }

          if (option === 2) {
            return {
              ...base,
              pickupsFrom: dataForm.applicationCargoPickup.timeWindowPickup.from
                ? getTime(dataForm.applicationCargoPickup.pickupDate, dataForm.applicationCargoPickup.timeWindowPickup.from)
                : undefined,
              pickupsTo: dataForm.applicationCargoPickup.timeWindowPickup.to
                ? getTime(dataForm.applicationCargoPickup.pickupDate, dataForm.applicationCargoPickup.timeWindowPickup.to)
                : undefined,
            };
          }

          return base;
        };

        const resolveDeliveryTimeFields = (option) => {
          const base = option ? { additionalServiceId: option} : undefined;

          const deliveryDateObj = dataForm.applicationCargoPickupTime.cargoTimePickupDelivery.startTime
            ? new Date(dataForm.applicationCargoPickupTime.cargoTimePickupDelivery.startTime)
            : new Date();

          if (option === 1 && dataForm.applicationCargoPickup.requestedTimeDelivery) {
            const t = dataForm.applicationCargoPickup.requestedTimeDelivery;
            const [h, m] = t.split(':').map(Number);
            const endMin = Math.min(h * 60 + m + 1, 23 * 60 + 59);
            const endStr = `${String(Math.floor(endMin / 60)).padStart(2, '0')}:${String(endMin % 60).padStart(2, '0')}`;
            return {
              ...base,
              deliveryFrom: getTime(deliveryDateObj, t),
              deliveryTo: getTime(deliveryDateObj, endStr),
            };
          }

          if (option === 2) {
            return {
              ...base,
              deliveryFrom: dataForm.applicationCargoPickup.timeWindowDelivery.from
                ? getTime(deliveryDateObj, dataForm.applicationCargoPickup.timeWindowDelivery.from)
                : undefined,
              deliveryTo: dataForm.applicationCargoPickup.timeWindowDelivery.to
                ? getTime(deliveryDateObj, dataForm.applicationCargoPickup.timeWindowDelivery.to)
                : undefined,
            };
          }

          return base;
        };

        let pickupTimeStart = new Date(dataForm.applicationCargoPickupTime.cargoTimePickup.startTime);
        let pickupTimeEnd = new Date(dataForm.applicationCargoPickupTime.cargoTimePickup.endTime);
        // let deliveryTimeStart = new Date(dataForm.applicationCargoPickupTime.cargoTimePickupDelivery.startTime);
        // let deliveryTimeEnd = new Date(dataForm.applicationCargoPickupTime.cargoTimePickupDelivery.endTime);

        pickupTimeStart = (pickupTimeStart.getHours() < 10 ? '0' : '') + pickupTimeStart.getHours() + ':' + (pickupTimeStart.getMinutes() < 10 ? '0' : '') + pickupTimeStart.getMinutes()
        pickupTimeEnd = (pickupTimeEnd.getHours() < 10 ? '0' : '') + pickupTimeEnd.getHours() + ':' + (pickupTimeEnd.getMinutes() < 10 ? '0' : '') + pickupTimeEnd.getMinutes()
        // deliveryTimeStart = (deliveryTimeStart.getHours() < 10 ? '0' : '') + deliveryTimeStart.getHours() + ':' + (deliveryTimeStart.getMinutes() < 10 ? '0' : '') + deliveryTimeStart.getMinutes()
        // deliveryTimeEnd = (deliveryTimeEnd.getHours() < 10 ? '0' : '') + deliveryTimeEnd.getHours() + ':' + (deliveryTimeEnd.getMinutes() < 10 ? '0' : '') + deliveryTimeEnd.getMinutes()

        const deliveryDateBase = dataForm.applicationCargoPickup.pickupDate ? new Date(dataForm.applicationCargoPickup.pickupDate) : new Date();
        deliveryDateBase.setDate(deliveryDateBase.getDate() + 1);
        // const deliveryStartTime = new Date(dataForm.applicationCargoPickupTime.cargoTimePickupDelivery.startTime);
        // const deliveryEndTime = new Date(dataForm.applicationCargoPickupTime.cargoTimePickupDelivery.endTime);

        const body = {
          comment: dataForm.services.sendTo
            ? `(Данные на водителя ${dataForm.services.sendTo}) ${dataForm.applicationCargoPickup.comment}`
            : dataForm.applicationCargoPickup.comment,
          additionalServices: dataForm.smsNotification ? [19] : undefined,
          transportation: {
            cityFrom: dataForm.sender.cityFrom,
            cityTo: dataForm.consignee.cityTo,
            officeTo: {
              id: dataForm.consignee.officeTo.id,
              address: dataForm.consignee.officeTo.address,
              title: dataForm.consignee.cityTo,
            }
          },

          cashOnDelivery: {
            sum: dataForm.services.cashOnDelivery ? Number(dataForm.services.cashOnDeliverySum) : 0,
          },

          sender: {
            phone: parsePhoneNumber(dataForm.sender.phoneSender),
            name: joinFullName(
              dataForm.sender.surnameSender,
              dataForm.sender.firstNameSender,
              dataForm.sender.secondNameSender
            ),
            email: dataForm.sender.emailSender,
            corpClient: dataForm.sender.senderType ? {
              inn: dataForm.sender.innSender,
              ...(dataForm.sender.senderType == 1 ? { kpp: dataForm.sender.kppSender } : {}),
              title: dataForm.sender.name,
              fullTitle: dataForm.sender.name,
            } : null,
            obligation: {
              ...generateObligation(),
            },
            obligationPattern: {
              comissionForCashOnDelivery: dataForm.services.cashOnDelivery,
              ...generateObligationPattern("Отправитель"),
            },
          },

          documentReturn: dataForm.services.returnOfDocuments,

          repurchaseCargo: dataForm.services.cargoRedemption
            ? {
                sum: Number(dataForm.services.cargoRedemptionSum),
                whoRepurchaseCargo: dataForm.services.whoPaysTheRansom
                  ? Number(dataForm.services.whoPaysTheRansom)
                  : 0,
              }
            : null,

          consignee: {
            phone: parsePhoneNumber(dataForm.consignee.phoneConsignee),
            inn: dataForm.consignee.consigneeType ? dataForm.consignee.innConsignee : "",
            kpp: dataForm.consignee.consigneeType == 1 ? dataForm.consignee.kppConsignee : "",
            name: joinFullName(
              dataForm.consignee.surnameConsignee,
              dataForm.consignee.firstNameConsignee,
              dataForm.consignee.secondNameConsignee
            ),
            title: dataForm.consignee.name,
            email: dataForm.consignee.emailConsignee,
            corpClient: dataForm.consignee.consigneeType ? {
              inn: dataForm.consignee.innConsignee,
              ...(dataForm.consignee.consigneeType == 1 ? { kpp: dataForm.consignee.kppConsignee } : {}),
              title: dataForm.consignee.name,
              fullTitle: dataForm.consignee.name,
            } : null,
            obligation: generateObligation(),
            obligationPattern: generateObligationPattern("Получатель"),
          },

          customer: {
            phone: parsePhoneNumber(dataForm.thirdPerson.phoneThirdPerson),
            name: joinFullName(
              dataForm.thirdPerson.surnameThirdPerson,
              dataForm.thirdPerson.firstNameThirdPerson,
              dataForm.thirdPerson.secondNameThirdPerson
            ),
            email: dataForm.thirdPerson.emailThirdPerson,
            corpClient: dataForm.thirdPerson.typeThirdPerson ? {
              inn: dataForm.thirdPerson.innThirdPerson,
              ...(dataForm.thirdPerson.typeThirdPerson == 1 ? { kpp: dataForm.thirdPerson.kppThirdPerson } : {}),
              title: dataForm.thirdPerson.name,
              fullTitle: dataForm.thirdPerson.name,
            } : null,
            obligation: generateObligation(),
            obligationPattern: generateObligationPattern("Третье лицо"),
          },

          pickUp: !dataForm.applicationCargoPickup.isCargoPickup
            ? null
            : {
                address: {
                  city: dataForm.sender.cityFrom,
                  address: dataForm.applicationCargoPickup.addressCargoPickup,
                  details: dataForm.applicationCargoPickup.addressCargoPickupNotice,
                },
                pickupsFrom: getTime(
                  dataForm.applicationCargoPickup.pickupDate,
                  pickupTimeStart
                ),
                pickupsTo: getTime(
                  dataForm.applicationCargoPickup.pickupDate,
                  pickupTimeEnd
                ),
                pickupsBreakFrom: getBreakTime(
                  dataForm.applicationCargoPickup.startTimeLunchBreak
                ),
                pickupsBreakTo: getBreakTime(
                  dataForm.applicationCargoPickup.endTimeLunchBreak
                ),
                powerOfAttorney: dataForm.services.typePowerOfAttorney
                  ? Number(dataForm.services.typePowerOfAttorney)
                  : 0,
                ...resolvePickUpTimeFields(dataForm.applicationCargoPickup.optionPickUp),
              },

          delivery: !dataForm.applicationCargoPickup.deliveryToTheAddress
            ? null
            : {
                address: {
                  city: dataForm.consignee.cityTo,
                  address: dataForm.applicationCargoPickup.addressConsignee,
                  details: dataForm.applicationCargoPickup.addressCargoPickupNoticeTo
                },
                deliveryFrom: new Date(dataForm.applicationCargoPickupTime.cargoTimePickupDelivery.startTime),
                deliveryTo: new Date(dataForm.applicationCargoPickupTime.cargoTimePickupDelivery.endTime),
                deliveryBreakFrom: getBreakTime(
                  dataForm.applicationCargoPickup.startTimeLunchBreakDelivery
                ),
                deliveryBreakTo: getBreakTime(
                  dataForm.applicationCargoPickup.endTimeLunchBreakDelivery
                ),
                ...resolveDeliveryTimeFields(dataForm.applicationCargoPickup.optionDelivery),
              },

          value: Number(dataForm.other.cargoCost),
          cargoList: CargoListArray,
        };

        if (
          !(dataForm.thirdPerson.cargoTransportationCustomer === "Третье лицо")
        ) {
          const obligation = { ...body.customer.obligation };
          const obligationPattern = { ...body.customer.obligationPattern };
          body.customer =
            dataForm.thirdPerson.cargoTransportationCustomer === "Отправитель"
              ? { ...body.sender }
              : { ...body.consignee };
          body.customer.obligation = obligation;
          body.customer.obligationPattern = obligationPattern;
        }

        console.log("body = ", body);
        const params = {
          number: "048",
        };

        const FormData = require('form-data');
        let formPrepareData = new FormData();
        formPrepareData.append('message', JSON.stringify(
                {
                  senderTitle:dataForm.sender.senderType ? dataForm.sender.name : body.sender.name,
                  senderPhone:body.sender.phone,
                  consigneeTitle: dataForm.consignee.consigneeType ? dataForm.consignee.name : body.consignee.name,
                  consigneePhone:body.consignee.phone,
                  AddressFrom:dataForm.applicationCargoPickup.isCargoPickup ? `${dataForm.sender.cityFrom}, ${dataForm.applicationCargoPickup.addressCargoPickup}, ${dataForm.applicationCargoPickup.addressCargoPickupNotice}` : `отсутствует, ${dataForm.sender.cityFrom}`,
                  AddressTo:dataForm.applicationCargoPickup.deliveryToTheAddress ? `${dataForm.consignee.cityTo}, ${dataForm.applicationCargoPickup.addressConsignee}, ${dataForm.applicationCargoPickup.addressCargoPickupNoticeTo}` : `отсутствует, ${dataForm.consignee.cityTo}`,
                  Volume:dataFormApi.cargoVolume,
                  Weight: dataFormApi.totalWeight,
                  Date: new Date().toLocaleString(),
                }
              ));
        formPrepareData.append('action', 'write_log');

        try {

          WORDPRESS.post(
            ``,
            formPrepareData
          ).catch(error => {
            console.log(error)
          });

          const { data } = await BACKEND.post(
            `/order/site?userid=${USER_ID}`,
            body,
            { params }
          ).catch(error => {
            console.log(error)
          });
          console.log(data);

          passDataPrint(data, dataForm.thirdPerson.cargoTransportationCustomer);

          // formEl.resetFields();
          // formEl.clearValidate();

          // dataForm.$reset();

          // Очищаем данные API
          // dataFormApi.$reset();

          // Object.assign(ruleForm, {
          //   applicationCargoPickup: dataForm.applicationCargoPickup,
          //   sender: dataForm.sender,
          //   consignee: dataForm.consignee,
          //   thirdPerson: dataForm.thirdPerson,
          //   services: dataForm.services,
          //   cargoInformation: dataForm.cargoInformation,
          //   payment: dataForm.payment,
          // });
      
          // Object.assign(rules, {
          //   // ...rulesForm,
          //   applicationCargoPickup: rulesForm.applicationCargoPickup(
          //     dataForm.applicationCargoPickup
          //   ),
          //   sender: rulesForm.sender(dataForm.sender),
          //   consignee: rulesForm.consignee(dataForm.consignee),
          //   thirdPerson: rulesForm.thirdPerson(dataForm.thirdPerson),
          //   cargoInformation: rulesForm.cargoInformation(dataForm.cargoInformation),
          //   services: rulesForm.services(dataForm.services),
          //   payment: rulesForm.payment(dataForm.payment),
          // });
      
          

          // Закрываем прослушивание
          // dataForm.cargoWatch();

          // dataForm.cargoWatch = watch(dataForm.cargoInformation, debounce(() => {
          //   refreshPackagesAPI();
          // }, 500)); 

          document.querySelector("body").classList.remove("loading-splash");



          // // После анимации возвращаем на пользователя на первую страницу
          // setTimeout(()=>{
          //   Object.assign(formTabs, {
          //     activeName: "services",
          //     tabs: [
          //       "services",
          //       "cargo-transportation-customer",
          //       "payment",
          //       "application-cargo-pickup",
          //       "cargo-information",
          //     ],
          //     arrayFormTads: {
          //       // eslint-disable-next-line no-unused-vars
          //       services: [...getArrayOfRules({cityFrom: dataForm.sender.cityFrom, officeFrom: dataForm.sender.officeFrom}, 'sender'),  ...getArrayOfRules({cityTo: dataForm.consignee.cityTo, officeTo: dataForm.consignee.officeTo}, 'consignee'), ...getArrayOfRules((({ typePowerOfAttorney, ...object }) => object)(dataForm.services), 'services')],
          //       counterparties: [
          //         // eslint-disable-next-line no-unused-vars
          //         ...getArrayOfRules((({ officeFrom, ...object }) => object)(dataForm.sender), "sender"),
          //         // eslint-disable-next-line no-unused-vars
          //         ...getArrayOfRules((({ officeTo, ...object }) => object)(dataForm.consignee), "consignee"),
          //         ...getArrayOfRules(dataForm.thirdPerson, "thirdPerson"),
          //       ],
          //       payment: [
          //         ...getArrayOfRules(dataForm.payment, "payment"),
          //       ],
          //       applicationCargoPickup: [
          //         ...getArrayOfRules(
          //           dataForm.applicationCargoPickup,
          //           "applicationCargoPickup"
          //         ),
          //       ],
          //       cargoInformation: [
          //         ...getArrayOfRules(dataForm.cargoInformation, "cargoInformation"),
          //       ],
                
          //     },
          //     // tabsError: {
          //     //   counterpartiesIsError: false,
          //     //   applicationCargoPickupIsError: false,
          //     //   cargoInformationIsError: false,
          //     //   servicesIsError: false,
          //     //   paymentIsError: false,
          //     // }
          //   });

          //   document.querySelector(".calculator__input-to").classList.remove("is-error");
          //   document.querySelector('.calculator__input-to .el-form-item__error').innerHTML = '';
          // }, 500)
          
          let fireworks = document.querySelectorAll('.firework');
          
          fireworks.forEach(item => {
              item.classList.add('active')
          })
          // dataForm.windowShow = true;
        } catch (e) {
          document.querySelector("body").classList.remove("loading-splash");

          dataForm.windowShow = true;
          dataForm.windowError = e;
          
          

          console.log(e);
        }
      },
      onPrint: async function () {
        

        const bodyCalc = {
          orderId: alertOfApplicationSubmission.orderId,
          customer: alertOfApplicationSubmission.customer,
          sender: alertOfApplicationSubmission.sender,
          consignee: alertOfApplicationSubmission.consignee
        };

        (async function () {
          try {
            const { data } = await NEWEST_BACKEND.post(
              `/public/lukevium-forwarding-receipt`,
              bodyCalc
            );
            
            pagePrint(data);
          } catch (e) {
            console.log(e);
          }
        })();
      },
      onPrintTalons: async function () {
        
        // var packageIds = [];

        // alertOfApplicationSubmission.cargoInfo.forEach(element => {
        //   packageIds.push(element.id)
        // });

        const bodyCalc = {
          orderId: alertOfApplicationSubmission.orderId
        };

        (async function () {
          try {
            const { data } = await NEWEST_BACKEND.post(
              `/public/marking-talons`,
              bodyCalc
            );
            
            pagePrintTalons(data);
          } catch (e) {
            console.log(e);
          }
        })();
      },
      
    };
    
  },
  

};

